import React, { useEffect, useState } from 'react';
import { DoorOpen } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '@/components/ui/switch';
import { errMsg } from '@/services/staffAttendanceApi';
import { ewbApi } from '@/services/ewayBillApi';
import { fmtDT } from '@/components/ewayBill/shared';

/** Admin switch: Gate Outward lets bundles out only on an ACTIVE e-way bill (turn off only in an emergency, e.g. Tally down). */
export const GateRuleSwitch = ({ canEdit }) => {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { ewbApi.gateRule().then(setR).catch(() => setR(null)); }, []);
  if (!r) return null;
  const flip = (on) => {
    setBusy(true);
    ewbApi.setGateRule(on).then((x) => { setR(x); toast[on ? 'success' : 'warning'](on ? 'Gate Outward now needs an e-way bill' : 'Gate Outward e-way bill check is OFF'); })
      .catch((e) => toast.error(errMsg(e, 'Could not change it'))).finally(() => setBusy(false));
  };
  return (
    <div className={`flex flex-wrap items-center gap-3 rounded-xl border px-4 py-3 ${r.enforce ? 'border-teal-200 bg-teal-50/60' : 'border-rose-300 bg-rose-50'}`} data-testid="ewb-gate-rule">
      <DoorOpen className={`w-5 h-5 ${r.enforce ? 'text-teal-700' : 'text-rose-600'}`} />
      <div className="text-sm">
        <div className="font-semibold" data-testid="ewb-gate-rule-state">{r.enforce ? 'Gate Outward needs an active e-way bill' : 'Gate Outward e-way bill check is OFF'}</div>
        <div className="text-xs text-gray-600">
          {r.enforce ? 'Internal Transfer / Job Order bundles leave only once their e-way bill number is in WMS.' : 'Bundles can leave without an e-way bill — switch it back on as soon as possible.'}
          {r.updated_by_name && ` · changed by ${r.updated_by_name} ${fmtDT(r.updated_at)}`}
        </div>
      </div>
      {canEdit && <Switch checked={r.enforce} disabled={busy} onCheckedChange={flip} className="ml-auto" data-testid="ewb-gate-rule-switch" />}
    </div>
  );
};

export default GateRuleSwitch;
